
export const PostCommentRowFooter = ({ children }) => {
  return <>{children}</>;
};
